(() => {
  const variantData = JSON.parse(document.querySelector('[data-product-variants]')?.textContent || '[]');
  const planData = window.ROAMUNO_PLAN_DATA?.bySku || {};
  const planLabels = window.ROAMUNO_PLAN_LABELS;
  if (!variantData.length || !Object.keys(planData).length) return;

  document.querySelectorAll('[data-product-facts]').forEach((facts) => {
    const currentVariant = facts.querySelector('[data-current-variant]');
    const productInfo = facts.closest('product-info');
    if (!currentVariant || !productInfo) return;

    const setRow = (name, value) => {
      const row = facts.querySelector(`[data-plan-row="${name}"]`);
      const target = row?.querySelector(`[data-plan-value="${name}"]`);
      const hasValue = value !== null && value !== undefined && String(value).trim() !== '';
      if (target && hasValue) target.textContent = value;
      if (row) row.hidden = !hasValue;
    };

    const setFaqFact = (name, value) => {
      const row = document.querySelector(`[data-faq-fact="${name}"]`);
      const answer = row?.querySelector('[data-faq-answer]');
      const hasValue = value !== null && value !== undefined && String(value).trim() !== '';
      if (answer && hasValue) answer.textContent = String(value);
      if (row) row.hidden = !hasValue;
    };

    const formatTopUp = (value) => {
      if (value === 'reloadable') return facts.dataset.topupReloadable || null;
      if (value === 'non_reloadable') return facts.dataset.topupNonReloadable || null;
      if (value === 'validity_extension_only') return facts.dataset.topupValidityExtensionOnly || null;
      return null;
    };

    const formatNetworks = (locations) => {
      if (!Array.isArray(locations)) return null;
      const normalized = locations.map((location) => {
        if (!location || !Array.isArray(location.carriers)) return null;
        const carriers = location.carriers.map((carrier) => {
          const name = typeof carrier?.name === 'string' ? carrier.name.trim() : '';
          if (!name) return null;
          const networkType = ['3G', '4G', '5G'].includes(carrier.networkType) ? carrier.networkType : null;
          return networkType ? `${name} — ${networkType}` : name;
        }).filter(Boolean);
        if (!carriers.length) return null;
        return {
          country: String(location.countryName || location.countryCode || '').trim(),
          carriers: carriers.join(', '),
        };
      }).filter(Boolean);
      if (!normalized.length) return null;
      if (normalized.length === 1) return normalized[0].carriers;
      return normalized.map((location) => location.country
        ? `${location.country}: ${location.carriers}`
        : location.carriers).join('; ');
    };

    const updateFromVariant = (variant) => {
      if (!variant) return;
      const record = planData[String(variant.sku || '')];
      if (!record) {
        currentVariant.textContent = '';
        ['networks', 'topup'].forEach((name) => setRow(name, null));
        setFaqFact('topup', null);
        setFaqFact('apn', null);
        return;
      }
      currentVariant.textContent = planLabels?.formatPlan(record) || '';
      setRow('networks', formatNetworks(record.networks));
      const topUp = formatTopUp(record.topUp);
      setRow('topup', topUp);
      setFaqFact('topup', topUp && facts.dataset.faqTopupTemplate
        ? facts.dataset.faqTopupTemplate.replaceAll('%%VALUE%%', topUp)
        : null);
      setFaqFact('apn', record.apn ? (facts.dataset.faqApnTemplate || 'APN information: %%VALUE%%').replaceAll('%%VALUE%%', record.apn) : null);
    };

    const update = () => {
      planLabels?.localize(document);
      const idInput = productInfo.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
      const selectedId = String(idInput?.value || '');
      const variant = variantData.find((candidate) => String(candidate.id) === selectedId);
      updateFromVariant(variant);
    };

    productInfo.addEventListener('change', update);
    productInfo.addEventListener('variant:change', update);
    update();
  });
})();
